import { useTranslation } from '@lyearn/i18n';
import { Box } from '@lyearn/ui';
import { FilterItemTooltipProps } from '@/components/Filter/types';
import { Filter } from '@/components/FilterManager';
import { NewFilterOption } from '@/components/FilterNew/types';

import useSubworkspacesFilter from './hooks/useSubworkspacesFilter';
import { WorkspacesFilterProps } from './types';

function WorkspaceFilter(props: WorkspacesFilterProps) {
  const { selectedValues, onChange, defaultPlaceholder, children, EmptyState, disabled } = props;
  const { t } = useTranslation('Workspace');
  const { state, methods } = useSubworkspacesFilter();
  const { filterGroups, searchStr, fetching, error } = state;
  const { setSearchStr } = methods;
  if (error) {
    return null;
  }

  if (disabled) {
    return <Box className="cursor-not-allowed">{children}</Box>;
  }

  if (EmptyState && searchStr.length === 0 && filterGroups.length === 0 && !fetching && !fetching) {
    return EmptyState;
  }

  const getTooltipProps: FilterItemTooltipProps = ({ option }: { option: NewFilterOption }) => {
    return {
      title: option.label,
      variant: 'default',
      placement: 'right',
    };
  };

  return (
    <Filter
      isGroupSelectionEnabled
      asyncOptions={{
        fetching,
        search: {
          placeholder: t('Workspace:SearchWorkspaces'),
          value: searchStr,
          onChange: setSearchStr,
        },
      }}
      getTooltipProps={getTooltipProps}
      groups={filterGroups}
      showActionButtons={false}
      value={selectedValues}
      onChange={onChange}>
      {children}
    </Filter>
  );
}

export default WorkspaceFilter;
